import React, { useContext } from 'react';
import { css } from '@emotion/react';
import { UserContext } from '@/components/App';
import { initialsFor } from '@/components/CorporateUsers/shippers/utils';
import {
    AccentBar,
    Card,
    CardRow,
    RoutingIcon,
    Section,
    SectionHeader,
    SectionTitle,
    StatusPill,
    StrongCell,
    SubCell,
} from '../blocks';

const grid = css`
    display: grid;
    gap: 20px;
    grid-template-columns: 1fr 1fr;
`;

const divider = css`
    border-top: 1px solid #e2e2e2;
`;

const IntegrationCard = ({ initials, tone, title, rows }) => (
    <Card>
        <CardRow>
            <div
                css={css`
                    align-items: flex-start;
                    display: flex;
                    gap: 12px;
                `}
            >
                <RoutingIcon tone={tone}>{initials}</RoutingIcon>
                <StrongCell>{title}</StrongCell>
            </div>
        </CardRow>
        {rows.map((row) => (
            <div key={row.label} css={divider}>
                <CardRow
                    css={css`
                        padding-bottom: 10px;
                        padding-top: 10px;
                    `}
                >
                    <SubCell
                        css={css`
                            margin: 0;
                        `}
                    >
                        {row.label}
                    </SubCell>
                    {row.pill ? <StatusPill tone={row.tone}>{row.value}</StatusPill> : <span>{row.value}</span>}
                </CardRow>
            </div>
        ))}
    </Card>
);

const Integrations = () => {
    // Context has already been overridden to the target shipper by index.jsx.
    const { client } = useContext(UserContext);
    const integrationType = client?.dispatch_integration_type;

    return (
        <Section>
            <SectionHeader>
                <AccentBar />
                <SectionTitle>Order Entry</SectionTitle>
            </SectionHeader>
            <div css={grid}>
                {/* Only `dispatch_integration_type` backs this card; nothing records the setup journey or last file. */}
                <IntegrationCard
                    initials={integrationType ? initialsFor(integrationType) : '—'}
                    tone="indigo"
                    title={integrationType || 'No integration'}
                    rows={[
                        {
                            label: 'Status',
                            value: integrationType ? 'Connected' : 'Setup',
                            pill: true,
                            tone: integrationType ? 'on' : 'off',
                        },
                    ]}
                />
                {/* "Onward tracking portal" goes here once Seats and Status are recorded. */}
            </div>
        </Section>
    );
};

export default Integrations;
